/**
 * 表示設定 Provider コンポーネント
 *
 * @file DisplaySettingsContext.tsx
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * 公開APIから取得した表示系設定を React context で供給する Provider。
 * Fast Refresh 互換のため DisplaySettingsProvider コンポーネントのみを export する。
 * context オブジェクトとフックは useDisplaySettings.ts を参照。
 */

import React from 'react';
import type { DisplaySettings } from './displaySettingsSnapshot';
import { DisplaySettingsContext } from './useDisplaySettings';

export type { DisplaySettings } from './displaySettingsSnapshot';

interface DisplaySettingsProviderProps {
  value: DisplaySettings;
  children: React.ReactNode;
}

export const DisplaySettingsProvider: React.FC<DisplaySettingsProviderProps> = ({ value, children }) => {
  return (
    <DisplaySettingsContext.Provider value={value}>
      {children}
    </DisplaySettingsContext.Provider>
  );
};
